import { createTheme } from '@mui/material/styles';
import { rtlFormComponentOverrides } from './rtlFormStyles';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Vazirmatn, Arial, sans-serif',
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  palette: {
    mode: 'light',
    primary: { main: '#00a86a', dark: '#037f4c', contrastText: '#ffffff' },
    secondary: { main: '#0073ea', dark: '#0060c2', contrastText: '#ffffff' },
    error: { main: '#e44258', dark: '#c9364a' },
    warning: { main: '#fdab3d' },
    success: { main: '#00c875' },
    info: { main: '#0073ea' },
    text: {
      primary: '#323338',
      secondary: '#676879',
      disabled: '#c5c7d0',
    },
    background: {
      default: '#f7f8fa',
      paper: '#ffffff',
    },
    divider: '#e6e9ef',
    action: {
      hover: '#f5f6f8',
      selected: '#e5f4ff',
    },
  },
  components: {
    ...rtlFormComponentOverrides,
    MuiLocalizationProvider: {
      defaultProps: {
        adapterLocale: 'fa'
      }
    },
    MuiContainer: {
      defaultProps: { maxWidth: 'lg' }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid #e6e9ef',
          boxShadow: '0 4px 20px rgba(50, 51, 56, 0.04)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
          fontWeight: 600,
          paddingTop: 12,
          paddingBottom: 12
        },
        startIcon: {
          marginLeft: 8,
          marginRight: 8
        },
        endIcon: {
          marginLeft: 8,
          marginRight: 8
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '& .MuiChip-icon': { marginLeft: 6, marginRight: 6 }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: { minWidth: 40 }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'medium'
      },
      styleOverrides: {
        root: {
          ...rtlFormComponentOverrides.MuiTextField.styleOverrides.root,
          '& .MuiOutlinedInput-root': {
            borderRadius: 12
          },
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: { root: { borderRadius: 16 } }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& th': { fontWeight: 700, background: '#f5f6f8' }
        }
      }
    }
  }
});

export default theme;


